import { CURRENCY_STRINGS } from "repoV2/constants/payment";
import { checkSystemTimezoneDomestic } from "repoV2/features/Common/modules/Timezone/Timezone.utils";
import {
    CREDS_ALREADY_EXISTS_CHOICES,
    EXTRA_FIELD,
    FORM_FIELDS,
} from "./FormData";

export const getBaseFormFields = ({
    isBooking,
    isValidMerchandise,
    detailsCount,
    hasToShowFullAddress,
    isInternationalCreator,
    isGSTStateNotInapplicable,
    currency,
}: {
    isBooking: boolean;
    isValidMerchandise?: boolean;
    detailsCount: number;
    showGstOption?: boolean;
    hasToShowFullAddress?: boolean;
    isInternationalCreator: boolean;
    isGSTStateNotInapplicable: boolean;
    currency?: string;
}) => {
    return [
        ...Object.values(FORM_FIELDS),
        ...(isBooking && isValidMerchandise && detailsCount === 1
            ? [EXTRA_FIELD.address, EXTRA_FIELD.city, EXTRA_FIELD.postal_code]
            : []),
        ...(!isBooking ? [EXTRA_FIELD.message] : []),
        ...(isBooking &&
        (isGSTStateNotInapplicable || isValidMerchandise) &&
        checkSystemTimezoneDomestic() &&
        !isInternationalCreator &&
        // Handling dynamic payment links for international transactions (specifically Custom Payment Links type)
        // This field renders a Billing State selector input field containing Indian states.
        // We do not want to display it if the currency is not INR.
        currency === CURRENCY_STRINGS.INR
            ? [EXTRA_FIELD.billing_state]
            : []),

        ...(isBooking && hasToShowFullAddress
            ? [
                  EXTRA_FIELD.stripe_address,
                  EXTRA_FIELD.city,
                  EXTRA_FIELD.state,
                  EXTRA_FIELD.postal_code,
              ]
            : []),
        ...(isBooking && hasToShowFullAddress && !isInternationalCreator
            ? [EXTRA_FIELD.payment_method]
            : []),
    ];
};

export const isProceedToUpdateAccountDetails = (choice: number) =>
    choice === CREDS_ALREADY_EXISTS_CHOICES.PROCEED_TO_UPDATE_ACCOUNT_DETAILS;

export const isProceedWithExistingAccountDetails = (choice: number) =>
    choice ===
    CREDS_ALREADY_EXISTS_CHOICES.PROCEED_WITH_ALREADY_EXISTING_DETAILS;
